<template>
    <div class="mx-auto" max-width="400">
        <v-toolbar-title>{{ $tr('Настройки') }}</v-toolbar-title>
        <div style="height: 16px;"></div>
        <div class="scrollable">
            <v-list-item>
                <template v-slot:prepend>
                    <v-list-item-action start>
                        <v-checkbox-btn v-model="webdav"></v-checkbox-btn>
                    </v-list-item-action>
                </template>
                <v-list-item-title>WebDAV</v-list-item-title>
                <v-list-item-subtitle>
                    {{ $tr('Разрешить доступ по протоколу WebDAV') }}
                </v-list-item-subtitle>
                <div style="height: 16px;"></div>
            </v-list-item>
            <v-list-item v-if="webdav">
                <v-text-field readonly :label="$tr('Логин')" :modelValue="payload.$api.me.user.uid"></v-text-field>
                <v-text-field v-if="webdavChanged" v-model="password" autofocus :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]" :type="showPassword ? 'text' : 'password'"
                    name="webdav-password" :label="$tr('Придумайте новый пароль')" :hint="$tr('Минимум 8 символов')" counter
                    @click:append="showPassword = !showPassword">
                </v-text-field>
            </v-list-item>
            <div v-for="item in settings" :key="item.id">
                <settings-item-view :item="item" :api="payload.$api"></settings-item-view>
            </div>
        </div>
    </div>
</template>

<script>
import md5 from 'crypto-js/md5';
import SettingsItemView from './SettingsItemView.vue';

export default {
    components: { SettingsItemView },
    name: 'SettingsView',
    props: {
        payload: Object,
    },
    data() {
        return {
            password: '',
            webdavChanged: false,
            showPassword: false,
            webdav: this.payload.webdav || false,
            rules: {
                required: (value) => !!value || this.$tr('Введите значение'),
                min: (value) => value.length >= 8 || this.$tr('Минимум 8 символов'),
            },
        };
    },
    methods: {
        finallize() {
            if (this.webdavChanged) {
                if (this.webdav) {
                    if (this.password.length < 8) {
                        return false;
                    }
                    const key = md5(`${this.payload.$api.me.user.uid}:${this.payload.fqdn}:${this.password}`).toString();
                    this.payload.$api.setSettings('webdav', key);
                } else {
                    this.payload.$api.setSettings('webdav', '');
                }
            }
            return true;
        },
        findSettings(id) {
            for (let i = 0; i < this.payload.settings.length; i += 1) {
                const settings = this.payload.settings[i];
                if (settings.id === id) {
                    return settings;
                }
            }
            return undefined;
        },
    },
    computed: {
        settings() {
            const me = this.payload.$api.me.user;
            const settings = [];
            settings.push({
                title: this.$tr('Персональные'),
                ...this.findSettings(me.id),
            });
            const companies = me.companies;
            if (companies != null) {
                for (let i = 0; i < companies.length; i += 1) {
                    const item = this.findSettings(companies[i].id);
                    if (item != null) {
                        settings.push({
                            title: companies[i].name,
                            ...item,
                        });
                    }
                }
            }
            return settings;
        },
    },
    watch: {
        webdav() {
            this.webdavChanged = true;
        },
    },
};
</script>

<style scoped>
.scrollable{
    height: 60vh;
    overflow-y: auto;
}
</style>
